import React, { ReactElement, useRef, useState } from 'react';
import { DownOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import Flexbox from '@common/components/Flexbox';
import { useOutsideClickHandler } from '@common/hooks';
import { AccountItem } from '@features/navigation/hooks/interfaces';
import * as Styled from './AccountDropdown.styled';

interface AccountDropdownProps {
  loading: boolean;
  selectedAccounts: AccountItem[];
  accounts: AccountItem[];
  onChangeAccount: (account: AccountItem) => void;
}

const AccountDropdown: React.FC<AccountDropdownProps> = ({
  loading,
  selectedAccounts,
  accounts,
  onChangeAccount,
}): ReactElement => {
  const ref = useRef(null);
  const [open, setOpen] = useState(false);

  useOutsideClickHandler(ref, () => setOpen(false));

  const handleAccountDropdownRender = (menu: ReactElement): ReactElement => (
    <Styled.AccountDropdownMenuWrapper>{menu}</Styled.AccountDropdownMenuWrapper>
  );

  const handleSelectAccount = (_, account: AccountItem): void => {
    onChangeAccount(account);
    setOpen(false);
  };

  const selectedAccountName = selectedAccounts?.[0]?.label || '';

  const handleFilterOption = (input: string, option?: { label: string; value: string }): boolean =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

  return (
    <Flexbox flexDirection='column'>
      {loading ? (
        <Spin />
      ) : (
        <>
          {open ? (
            <div ref={ref} id='account-dropdown-wrapper'>
              <Styled.AccountSelectWrapper
                autoFocus
                showSearch
                data-test-id='account-dropdown-select'
                getPopupContainer={() => document.getElementById('account-dropdown-wrapper')}
                open={open}
                onSelect={handleSelectAccount}
                filterOption={handleFilterOption}
                bordered={false}
                options={accounts}
                fieldNames={{ value: 'key' }}
                dropdownRender={handleAccountDropdownRender}
                value={selectedAccounts}
                popupMatchSelectWidth={270}
                listHeight={450}
              />
            </div>
          ) : (
            <Styled.AccountDropdownTitle data-test-id='account-dopdown-title' onClick={() => setOpen(true)}>
              Account <DownOutlined />
            </Styled.AccountDropdownTitle>
          )}
          <Styled.AccountDropdownSelectedText>{selectedAccountName}</Styled.AccountDropdownSelectedText>
        </>
      )}
    </Flexbox>
  );
};

export default AccountDropdown;
